import { BaseModel, propertyChangedArguments } from "../BaseModel";

export class TherapistModel extends BaseModel {

    constructor(source?: TherapistModel) {
        super();
        if (source != null) {
            this.copyIn(source);
        }
        else
        {
            this._therapistID = 0;
            this._systemUserID = 0;
            this._therapistStatusID = 0;
        }
    }

// private properties
    _therapistID: number = 0;
    _systemUserID: number = 0;
    _email: string = "";
    _firstName: string = "";
    _lastName: string = "";
    _profileLarge: string | null = null;
    _profileSmall: string | null = null;
    _profileLargeURL: string | null = null;
    _profileSmallURL: string | null = null;
    _therapistStatusID: number = 0;
    _startTime: string | null = null;
    _endTime: string | null = null;
    _acceptBookings: boolean = true;
    _working: boolean = true;
    _active: boolean = true;

// public properties
    public get therapistID(): number
    {
        return this._therapistID;
    }
    public set therapistID(v: number)
    {
        if (v !== this._therapistID)
        {
            this._therapistID = v;
            this.propertyChanged.emit(new propertyChangedArguments("therapistID", this));
        }
    }

    public get systemUserID(): number
    {
        return this._systemUserID;
    }
    public set systemUserID(v: number)
    {
        if (v !== this._systemUserID)
        {
            this._systemUserID = v;
            this.propertyChanged.emit(new propertyChangedArguments("systemUserID", this));
        }
    }

    public get email(): string
    {
        return this._email;
    }
    public set email(v: string)
    {
        if (v !== this._email)
        {
            this._email = v;
            this.propertyChanged.emit(new propertyChangedArguments("email", this));
        }
    }

    public get firstName(): string
    {
        return this._firstName;
    }
    public set firstName(v: string)
    {
        if (v !== this._firstName)
        {
            this._firstName = v;
            this.propertyChanged.emit(new propertyChangedArguments("firstName", this));
        }
    }

    public get lastName(): string
    {
        return this._lastName;
    }
    public set lastName(v: string)
    {
        if (v !== this._lastName)
        {
            this._lastName = v;
            this.propertyChanged.emit(new propertyChangedArguments("lastName", this));
        }
    }

    public get profileLarge(): string | null
    {
        return this._profileLarge;
    }
    public set profileLarge(v: string | null)
    {
        if (v !== this._profileLarge)
        {
            this._profileLarge = v;
            this.propertyChanged.emit(new propertyChangedArguments("profileLarge", this));
        }
    }

    public get profileSmall(): string | null
    {
        return this._profileSmall;
    }
    public set profileSmall(v: string | null)
    {
        if (v !== this._profileSmall)
        {
            this._profileSmall = v;
            this.propertyChanged.emit(new propertyChangedArguments("profileSmall", this));
        }
    }

    public get profileLargeURL(): string | null
    {
        return this._profileLargeURL;
    }
    public set profileLargeURL(v: string | null)
    {
        if (v !== this._profileLargeURL)
        {
            this._profileLargeURL = v;
            this.propertyChanged.emit(new propertyChangedArguments("profileLargeURL", this));
        }
    }

    public get profileSmallURL(): string | null
    {
        return this._profileSmallURL;
    }
    public set profileSmallURL(v: string | null)
    {
        if (v !== this._profileSmallURL)
        {
            this._profileSmallURL = v;
            this.propertyChanged.emit(new propertyChangedArguments("profileSmallURL", this));
        }
    }

    public get therapistStatusID(): number
    {
        return this._therapistStatusID;
    }
    public set therapistStatusID(v: number)
    {
        if (v !== this._therapistStatusID)
        {
            this._therapistStatusID = v;
            this.propertyChanged.emit(new propertyChangedArguments("therapistStatusID", this));
        }
    }

    public get startTime(): string | null
    {
        return this._startTime;
    }
    public set startTime(v: string | null)
    {
        if (v !== this._startTime)
        {
            this._startTime = v;
            this.propertyChanged.emit(new propertyChangedArguments("startTime", this));
        }
    }

    public get endTime(): string | null
    {
        return this._endTime;
    }
    public set endTime(v: string | null)
    {
        if (v !== this._endTime)
        {
            this._endTime = v;
            this.propertyChanged.emit(new propertyChangedArguments("endTime", this));
        }
    }

    public get acceptBookings(): boolean
    {
        return this._acceptBookings;
    }
    public set acceptBookings(v: boolean)
    {
        if (v !== this._acceptBookings)
        {
            this._acceptBookings = v;
            this.propertyChanged.emit(new propertyChangedArguments("acceptBookings", this));
        }
    }

    public get working(): boolean
    {
        return this._working;
    }
    public set working(v: boolean)
    {
        if (v !== this._working)
        {
            this._working = v;
            this.propertyChanged.emit(new propertyChangedArguments("working", this));
        }
    }

    public get active(): boolean
    {
        return this._active;
    }
    public set active(v: boolean)
    {
        if (v !== this._active)
        {
            this._active = v;
            this.propertyChanged.emit(new propertyChangedArguments("active", this));
        }
    }


    override assignChildren(): void {
        super.assignChildren();
    }

    copyIn(source: TherapistModel): void {
        if (source == null) return;
        this._therapistID = source.therapistID;
        this._systemUserID = source.systemUserID;
        this._email = source.email;
        this._firstName = source.firstName;
        this._lastName = source.lastName;
        this._profileLarge = source.profileLarge;
        this._profileSmall = source.profileSmall;
        this._profileLargeURL = source.profileLargeURL;
        this._profileSmallURL = source.profileSmallURL;
        this._therapistStatusID = source.therapistStatusID;
        this._startTime = source.startTime;
        this._endTime = source.endTime;
        this._acceptBookings = source.acceptBookings;
        this._working = source.working;
        this._active = source.active;
    }


}
